<script>

import t from '@/components/page/HomeView/data/text.json'

export default {

  data() {
    return {
      t
    }
  },
}
</script>

<template>
  <section class="list-page">
    <div class="content">
      <router-link :to="item.link" :class="`list-page__item js-scroll scrolled fade-in-bottom delay${id+1}`"
                   v-for="(item, id) in t.itemPages" :key="id">
        <div class="list-page__img">
          <div class="list-page__img-icon">

            <svg class="list-page__img-icon--icon1" v-show="item.link === 'article1' || item.link === 'article2'" width="18" height="9"
                 viewBox="0 0 18 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M4.22767 2.05519C3.5947 2.05519 2.98766 2.30097 2.54009 2.73845C2.09251 3.17593 1.84107 3.76928 1.84107 4.38798C1.84107 5.00667 2.09251 5.60002 2.54009 6.03751C2.98766 6.47499 3.5947 6.72076 4.22767 6.72076C4.86063 6.72076 5.46767 6.47499 5.91525 6.03751C6.36282 5.60002 6.61427 5.00667 6.61427 4.38798C6.61427 3.76928 6.36282 3.17593 5.91525 2.73845C5.46767 2.30097 4.86063 2.05519 4.22767 2.05519ZM0.25 4.38798C0.250079 3.64981 0.465146 2.92691 0.870055 2.30381C1.27496 1.6807 1.85298 1.18314 2.53653 0.869304C3.22007 0.555464 3.9809 0.438312 4.73005 0.531545C5.47921 0.624778 6.18573 0.924543 6.76701 1.39579C7.36168 0.821007 8.16454 0.499056 9.00087 0.500002C9.87197 0.500002 10.6603 0.842144 11.2347 1.39579C11.9932 0.78159 12.9579 0.464301 13.9419 0.50535C14.926 0.5464 15.8595 0.942867 16.5617 1.618C17.2639 2.29313 17.6848 3.19891 17.743 4.15998C17.8013 5.12105 17.4926 6.06905 16.8768 6.82047C16.2611 7.57188 15.382 8.07325 14.4097 8.22752C13.4375 8.3818 12.4413 8.178 11.6139 7.65558C10.7866 7.13316 10.187 6.32928 9.93116 5.39956C9.67535 4.46985 9.78154 3.48042 10.2292 2.62284C10.0801 2.44529 9.89267 2.30228 9.68027 2.20412C9.46786 2.10596 9.23582 2.05509 9.00087 2.05519C8.50764 2.05519 8.06452 2.27525 7.77256 2.62284C8.04527 3.14654 8.19298 3.72386 8.20459 4.31139C8.2162 4.89892 8.0914 5.48138 7.83959 6.01499C7.58777 6.5486 7.21548 7.01947 6.7507 7.39221C6.28592 7.76495 5.74075 8.02986 5.15616 8.16703C4.57157 8.3042 3.96278 8.31006 3.37554 8.18418C2.7883 8.05829 2.2379 7.80392 1.7657 7.4402C1.2935 7.07648 0.91179 6.61287 0.649267 6.08422C0.386744 5.55556 0.250234 4.97562 0.25 4.38798ZM13.7741 2.05519C13.4605 2.05478 13.15 2.11484 12.8603 2.23193C12.5705 2.34902 12.3073 2.52084 12.0856 2.73754C11.8639 2.95424 11.6881 3.21156 11.5683 3.49478C11.4485 3.77799 11.387 4.08152 11.3875 4.38798C11.3875 4.84936 11.5274 5.30038 11.7897 5.684C12.0519 6.06763 12.4247 6.36663 12.8608 6.54319C13.2968 6.71975 13.7767 6.76595 14.2397 6.67594C14.7026 6.58593 15.1279 6.36375 15.4616 6.03751C15.7954 5.71126 16.0227 5.2956 16.1148 4.84308C16.2069 4.39057 16.1596 3.92152 15.979 3.49526C15.7984 3.069 15.4925 2.70467 15.1 2.44834C14.7075 2.19201 14.2461 2.05519 13.7741 2.05519Z"
                fill="white"/>
            </svg>

            <svg class="list-page__img-icon--icon2" v-show="item.link === 'interactive-video'" width="12"
                 height="14"
                 viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M0.125 2.81547C0.125 1.11162 2.02394 0.0953351 3.44163 1.04046L10.122 5.49404C11.3886 6.33845 11.3886 8.19966 10.122 9.04406L3.44163 13.4976C2.02394 14.4428 0.125 13.4265 0.125 11.7226V2.81547ZM2.65274 2.2238C2.18018 1.90876 1.5472 2.24752 1.5472 2.81547V11.7226C1.5472 12.2906 2.18018 12.6293 2.65274 12.3143L9.33311 7.86072C9.75531 7.57925 9.75531 6.95885 9.33311 6.67738L2.65274 2.2238Z"
                    fill="white"/>
            </svg>

            <svg class="list-page__img-icon--icon3" v-show="item.link === 'quiz'" width="30" height="30"
                 viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M14.9843 23.424C15.4126 23.424 15.7744 23.2763 16.0696 22.9808C16.3649 22.685 16.5125 22.3229 16.5125 21.8944C16.5125 21.4661 16.3646 21.1044 16.0689 20.8091C15.7731 20.5141 15.4111 20.3666 14.9828 20.3666C14.5546 20.3666 14.1928 20.5145 13.8976 20.8102C13.6023 21.106 13.4547 21.468 13.4547 21.8963C13.4547 22.3245 13.6026 22.6863 13.8983 22.9815C14.1941 23.2765 14.5561 23.424 14.9843 23.424ZM13.9219 18.0528H16.0336C16.0529 17.3145 16.161 16.7246 16.358 16.2831C16.5552 15.8419 17.0336 15.2568 17.7932 14.5281C18.4529 13.8683 18.9582 13.259 19.3089 12.7003C19.66 12.1418 19.8355 11.4821 19.8355 10.7214C19.8355 9.43007 19.3716 8.42142 18.4438 7.69541C17.5158 6.96964 16.4181 6.60675 15.1508 6.60675C13.8988 6.60675 12.8628 6.94089 12.0428 7.60915C11.2225 8.27742 10.6374 9.06444 10.2873 9.97021L12.2141 10.7431C12.3969 10.2451 12.7094 9.75996 13.1517 9.2877C13.5939 8.81568 14.2507 8.57968 15.122 8.57968C16.0085 8.57968 16.6638 8.82243 17.0878 9.30794C17.512 9.79371 17.7242 10.3278 17.7242 10.9104C17.7242 11.4201 17.5789 11.8865 17.2884 12.3095C16.9981 12.7325 16.628 13.1412 16.178 13.5354C15.1932 14.4239 14.5711 15.1327 14.3116 15.6617C14.0518 16.1905 13.9219 16.9875 13.9219 18.0528ZM15.0035 29.2513C13.0324 29.2513 11.1797 28.8773 9.44545 28.1293C7.71116 27.3813 6.20262 26.3661 4.91984 25.0838C3.63706 23.8016 2.62141 22.2936 1.87289 20.5601C1.12462 18.8266 0.750488 16.9744 0.750488 15.0036C0.750488 13.0325 1.1245 11.1799 1.87252 9.44557C2.62053 7.71128 3.63568 6.20274 4.91797 4.91996C6.20025 3.63718 7.70816 2.62153 9.4417 1.87301C11.1752 1.12474 13.0274 0.75061 14.9982 0.75061C16.9693 0.75061 18.8219 1.12462 20.5562 1.87264C22.2905 2.62066 23.7991 3.63581 25.0818 4.91809C26.3646 6.20037 27.3803 7.70828 28.1288 9.44182C28.8771 11.1754 29.2512 13.0275 29.2512 14.9983C29.2512 16.9694 28.8772 18.8221 28.1292 20.5563C27.3811 22.2906 26.366 23.7992 25.0837 25.082C23.8014 26.3647 22.2935 27.3804 20.56 28.1289C18.8264 28.8772 16.9743 29.2513 15.0035 29.2513ZM15.0008 27.0013C18.3509 27.0013 21.1885 25.8387 23.5135 23.5137C25.8386 21.1886 27.0011 18.351 27.0011 15.001C27.0011 11.6509 25.8386 8.81331 23.5135 6.48825C21.1885 4.16319 18.3509 3.00067 15.0008 3.00067C11.6508 3.00067 8.81319 4.16319 6.48813 6.48825C4.16307 8.81331 3.00054 11.6509 3.00054 15.001C3.00054 18.351 4.16307 21.1886 6.48813 23.5137C8.81319 25.8387 11.6508 27.0013 15.0008 27.0013Z"
                fill="white"/>
            </svg>

            <svg class="list-page__img-icon--icon4" v-show="item.link === 'game'" width="13" height="15"
                 viewBox="0 0 13 15" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M3.09722 3.425C3.09722 2.68239 3.38403 1.9702 3.89454 1.4451C4.40506 0.919999 5.09747 0.625 5.81944 0.625C6.54142 0.625 7.23383 0.919999 7.74435 1.4451C8.25486 1.9702 8.54167 2.68239 8.54167 3.425H11.9444C12.1249 3.425 12.298 3.49875 12.4257 3.63003C12.5533 3.7613 12.625 3.93935 12.625 4.125V7.044C12.6251 7.15603 12.5991 7.26645 12.5491 7.36599C12.4991 7.46552 12.4266 7.55127 12.3378 7.61601C12.2489 7.68076 12.1462 7.72261 12.0383 7.73806C11.9304 7.75351 11.8205 7.74211 11.7178 7.7048C11.5126 7.63048 11.293 7.60785 11.0775 7.63882C10.862 7.66979 10.6568 7.75345 10.4792 7.88279C10.3017 8.01213 10.1568 8.18338 10.0568 8.38218C9.95688 8.58098 9.90471 8.80153 9.90471 9.02535C9.90471 9.24917 9.95688 9.46972 10.0568 9.66852C10.1568 9.86732 10.3017 10.0386 10.4792 10.1679C10.6568 10.2973 10.862 10.3809 11.0775 10.4119C11.293 10.4429 11.5126 10.4202 11.7178 10.3459C11.8204 10.3086 11.9302 10.2972 12.038 10.3126C12.1457 10.328 12.2483 10.3697 12.3372 10.4343C12.4261 10.4989 12.4986 10.5844 12.5486 10.6838C12.5987 10.7831 12.6249 10.8934 12.625 11.0053V13.925C12.625 14.1107 12.5533 14.2887 12.4257 14.42C12.298 14.5513 12.1249 14.625 11.9444 14.625H1.05556C0.875061 14.625 0.701959 14.5513 0.57433 14.42C0.446701 14.2887 0.375 14.1107 0.375 13.925V4.125C0.375 3.93935 0.446701 3.7613 0.57433 3.63003C0.701959 3.49875 0.875061 3.425 1.05556 3.425H3.09722ZM5.81944 2.025C5.60164 2.02494 5.38701 2.07865 5.19357 2.1816C5.00014 2.28456 4.83354 2.43376 4.70779 2.61667C4.58204 2.79958 4.50079 3.01086 4.47089 3.23276C4.44098 3.45466 4.46328 3.6807 4.53592 3.8919C4.57219 3.99754 4.58328 4.11058 4.56826 4.22154C4.55323 4.3325 4.51254 4.43813 4.44959 4.52955C4.38665 4.62098 4.30329 4.69553 4.20652 4.74694C4.10974 4.79835 4.00239 4.82512 3.89347 4.825H1.73611V13.225H11.2639V11.825C10.5419 11.825 9.8495 11.53 9.33899 11.0049C8.82847 10.4798 8.54167 9.76761 8.54167 9.025C8.54167 8.28239 8.82847 7.5702 9.33899 7.0451C9.8495 6.52 10.5419 6.225 11.2639 6.225V4.825H7.74542C7.6365 4.82512 7.52915 4.79835 7.43237 4.74694C7.3356 4.69553 7.25224 4.62098 7.1893 4.52955C7.12635 4.43813 7.08565 4.3325 7.07063 4.22154C7.05561 4.11058 7.0667 3.99754 7.10297 3.8919C7.17561 3.6807 7.19791 3.45466 7.168 3.23276C7.13809 3.01086 7.05685 2.79958 6.9311 2.61667C6.80534 2.43376 6.63875 2.28456 6.44532 2.1816C6.25188 2.07865 6.03725 2.02494 5.81944 2.025Z"
                fill="white"/>
            </svg>


          </div>

          <picture>
            <source media="(max-width: 600px)" :srcset="require(`@/assets/img/page/HomeView/mob/${item.img}.webp`)"
                    type="image/webp">
            <source media="(max-width: 600px)" :srcset="require(`@/assets/img/page/HomeView/mob/${item.img}.png`)"
                    type="image/jpeg">

            <source media="(min-width: 526px) and (max-width: 768px)"
                    :srcset="require(`@/assets/img/page/HomeView/tablet/${item.img}.webp`)" type="image/webp">
            <source media="(min-width: 526px) and (max-width: 768px)"
                    :srcset="require(`@/assets/img/page/HomeView/tablet/${item.img}.png`)" type="image/jpeg">

            <source media="(min-width: 769px)" :srcset="require(`@/assets/img/page/HomeView/desk/${item.img}.webp`)"
                    type="image/webp">
            <img class="list-page__img-main" :src="require(`@/assets/img/page/HomeView/desk/${item.img}.png`)"
                 :alt="`${item.name}`">
          </picture>
        </div>
        <p class="list-page__type" v-html="item.iconType"></p>
        <h2 class="list-page__title" v-html="item.name"></h2>
      </router-link>
    </div>
  </section>
</template>

<style scoped lang="scss">
.list-page {
  padding: 24px 60px 54px 60px;
  display: flex;
  justify-content: center;

  @media screen and (max-width: 1024px) {
    padding: 24px 20px;
  }

  .content {
    max-width: 1320px;

    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);

    gap: 40px 24px;

    @media screen and (max-width: 1024px) {
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(3, 1fr);

      gap: 40px 20px;
    }

    @media screen and (max-width: 600px) {
      gap: 24px 8px;
    }
  }

  &__item {
    width: 100%;
    position: relative;
    z-index: 20;

    @media screen and (min-width: 1024px) {
      &:hover {
        user-select: none;
        cursor: pointer;

        .list-page__img-icon {
          background: linear-gradient(0deg, #01CB93 0%, #60FE94 100%);
          box-shadow: 0 7px 20px rgba(156, 255, 172, 0.4);
        }
      }
    }

    &:active {
      user-select: none;

      .list-page__img-icon {
        border-color: rgba(255, 255, 255, 0.30);

        background: radial-gradient(66.84% 40% at 50% 0%, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0) 100%), linear-gradient(0deg, #00A275 0%, #60FE94 100%), linear-gradient(0deg, #01CB93 0%, #60FE94 100%), linear-gradient(0deg, #00B59C 0%, #9CFFAC 100%);
        box-shadow: 0px 7px 20.1px rgba(156, 255, 172, 0.4);

        &:after {
          opacity: 1;
        }
      }
    }

    &:nth-child(1) {
      .list-page__title {
        //max-width: 80%;
        width: 100%;
      }
    }
  }

  &__img {
    position: relative;

    &-icon {
      position: absolute;
      left: 0;
      bottom: 0;

      width: 14.16%;
      height: 18.26%;

      background: linear-gradient(0deg, #22B28A 0%, #6FD691 100%);
      border-radius: 50%;

      display: flex;
      justify-content: center;
      align-items: center;
      //border: 2px solid rgba(255, 255, 255, 0);

      overflow: hidden;

      &:after {
        content: '';
        position: absolute;
        width: calc(100% - 4px);
        height: calc(100% - 4px);
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        border: 2px solid rgba(255, 255, 255, 0.30);

        border-radius: 50%;
        opacity: 0;
      }

      @media screen and (max-width: 768px) {
        width: 17.40%;
        height: 22.48%;
      }

      @media screen and (max-width: 600px) {
        width: 21.74%;
        height: 28.03%;
      }

      svg {
        position: relative;
        z-index: 2;

        height: auto;
        display: block;
      }

      &--icon1 {
        width: 52%;
      }

      &--icon2 {
        width: 33.3%;
      }

      &--icon3 {
        width: 50%;

      }

      &--icon4 {
        width: 45.4%;
      }
    }

    &-main {
      display: block;
      width: 100%;
      height: auto;
    }
  }

  &__type {
    color: var(--9CFFAC, #9CFFAC);

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%;
    letter-spacing: 0.56px;
    text-transform: uppercase;
    margin-bottom: 8px;
    margin-top: 14px;

    @media screen and (max-width: 600px) {
      font-size: 10px;
    }
  }

  &__title {
    color: var(--Text-White, #FFF);
    font-family: 'MetaPro', sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 110%;
    letter-spacing: 0.24px;
    text-transform: uppercase;

    ::v-deep(br) {
      display: none;
    }


    @media screen and (max-width: 600px) {
      font-size: 14px;
    }
  }


}
</style>